import o from"styled-components";const e=o.div`
	.caelor-custom-select__control {
		background-color: ${({theme:o})=>o.bg.primary};
		border-radius: 8px;
		box-sizing: border-box;
		border: none;
		width: 100%;
		font-size: 13.3333px;
		color: ${({theme:o})=>o.bg.black};

		&:focus {
			outline: none;
		}

		&:hover {
			background-color: ${({theme:o})=>o.border.black10};
		}

		.caelor-custom-select__single-value {
			color: ${({theme:o})=>o.bg.black} !important;
		}

		.caelor-custom-select__dropdown-indicator {
			display: ${({hideDropdownIcon:o})=>o?"none":"block"};
		}

		.caelor-custom-select__clear-indicator {
			padding-right: ${({hideDropdownIcon:o})=>o?"7px":"0px"};
		}
	}

	.caelor-custom-select__option {
		font-size: 13.3333px;
		color: ${({theme:o})=>o.bg.black};
		box-shadow: none;
		cursor: pointer;

		&:hover {
			background-color: ${({theme:o})=>o.border.black10};
		}
	}
	.caelor-custom-select__option--is-selected {
		background-color: ${({theme:o})=>o.bg.primary};
	}
	.caelor-custom-select__option--is-focused {
		background-color: ${({theme:o})=>o.bg.secondary};
	}
`;export{e as SelectContainer};
